import { http, createConfig } from 'wagmi'
import { bsc, bscTestnet } from 'wagmi/chains'
import { injected, metaMask, safe, walletConnect } from 'wagmi/connectors'

const projectId = '75f0ab21a52cbff7e566bcc9be983646'

export const config = createConfig({
  chains: [bsc],
  connectors: [injected(), walletConnect({ projectId }),], 
  ssr: true,
  // rpcSchema:{ 56: "https://binance.llamarpc.com"},
  transports: {
    // [bsc.id]: http(),
   [bsc.id]: http("https://bsc-mainnet.nodereal.io/v1/64a9df0874fb4a93b9d0a3849de012d3")
  },
})